import React from 'react';

export const EmptyFilters = (): JSX.Element => (
  <>
    <h4 className="pb-4">No saved filters yet</h4>
    <p className="text-sm">Configure a filter then apply it before saving.</p>
  </>
);
